import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

class MarketingAttachments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectionStart: null,
      selectedField: ''
    };

  }

  render() {
    return (
      <Row className='pb-4 text-left'>
        <p className='font-weight-bold pl-4 pt-2 mt-2'>Attachments</p>
        {this.props.attachments != null && this.props.attachments.map((attachment, attachmentIndex) => (
          <Fragment key={attachment}>
            <Col md={10} className="mb-2">
              <Input
                name="attachment"
                type="select"
                id={"attachment_" + attachmentIndex}
                onChange={(e) => this.props.onChange(e, (this.props.edit ? "edit" : "new"))}
                value={attachment}
              >
                {/* <option value={0}>Attachment</option> */}
                {this.props.files != null && this.props.files.filter(file => this.props.attachments.findIndex(at => at === file.uuid && at !== attachment) === -1).map(file => (
                  <option key={file.uuid} value={file.uuid}>{file.filename}</option>
                ))}
              </Input>
            </Col>
            <Col md={2} className='text-left'>
              <Button className="mb-2" color="secondary" onClick={() => this.props.handleRemoveAttachment(attachmentIndex, (this.props.edit ? "edit" : "new"))} title="Cancel">
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Col>
          </Fragment>
        ))}
        {this.props.attachments != null && this.props.files != null && this.props.files.filter(file => this.props.attachments.findIndex(at => at === file.uuid) === -1).length > 0 && <>
          <Col md={10} className="mb-2">
            <Input
              name="attachment"
              type="select"
              id={"attachment_-1"}
              onChange={(e) => this.props.onChange(e, (this.props.edit ? "edit" : "new"))}
            // value={}
            >
              <option value={0}>Attachment</option>
              {this.props.files.filter(file => this.props.attachments.findIndex(at => at === file.uuid) === -1).map(file => (
                <option key={file.uuid} value={file.uuid}>{file.filename}</option>
              ))}
            </Input>
          </Col>
        </>}
      </Row>
    );

  }
}

export default MarketingAttachments;
